<xemex-page-header
  [title]="'sidebarMenu.partners' | translate"
  [breadcrumbs]="[{ label: 'sidebarMenu.home' | translate, routerLink: '/' }, { label: 'sidebarMenu.partners' | translate }]"
></xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [loading]="companyStore.isLoading()"
    [totalCount]="totalCount()"
    [rowLink]="rowLink"
    (pageChange)="onPageChange($event)"
  >
    <xemex-table-filter-bar
      [filterGroups]="filterGroups()"
      [searchPlaceholder]="'companies.filter.placeholderSearch' | translate"
      (searchChange)="onSearchChange($event)"
      (filterChange)="onFilterChange($event)"
    ></xemex-table-filter-bar>
  </xemex-table>
</xemex-page-body>
